import React from 'react'
import './IncentiveHeader.css';
import { IconButton } from '@mui/material';
import { KeyboardArrowDown } from '@material-ui/icons';

export const IncentiveHeader = (props:{heading:string, open:boolean, showList?:boolean, setShowList?:React.Dispatch<React.SetStateAction<boolean>>, children? : JSX.Element})=>{
    return <div className={`incentive-header ${props.open ? 'open' : 'close'}`} >
        <div className={`incentive-header-top ${props.open ? 'open' : 'close'}`}>
            <div>
                {props.heading}
            </div>
            <div>
                {props.open && !props.showList && props.setShowList
                    ?<IconButton size="small" onClick={(e) => { e.stopPropagation(); props.setShowList!(true) }}>
                        <KeyboardArrowDown/>
                    </IconButton>
                    :<></>
                }
            </div>
        </div>
        { props.open ?
            <div className='incentive-header-body'>
                {props.children}
            </div> 
            : <></>
        }
    </div>
}